var actionTypes = require('../constants/action_types');

module.exports = {
  initialize: function() {
    this.__state = {
      logs: [],
    };

    this.on(actionTypes.LOG, this.__addLog);
  },

  getLogs: function() {
    return this.__state.logs;
  },

  __addLog: function(payload) {
    this.__state.logs.push(payload);
    this.emitChange();
  },

  __getState: function() {
    // Use slice instead of default cloneDeep for performance
    return this.__state.logs.slice();
  },
};
